//@ts-ignore
import React, { useState, useEffect } from 'react'
import { saveAndEditClient, getClient, getClientRole, saveAndEditUser, getUsers } from './ClientServices'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
const styles = {
    padding: { padding: '5px 10px' }
}

const UserComponent = (props: any) => {
    const [email, setEmail] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [role, setRole] = useState('')
    const [isActive, setIsActive] = useState('true')
    const [password, setPassword] = useState('')
    const [resMsg, setResMsg] = useState('')
    const [client, setClient] = useState(null)
    const [clients, setClients] = useState([])
    const [clientRoles, setClientRoles] = useState([])
    const [editUser, setEditUser] = useState(null)
    const [users, setUsers] = useState([])
    const [editUserIndex, setEditUserIndex] = useState(-1)
    useEffect(() => {
        getClient('')
            .then((res: any) => {
                setClients(res.responseObject)
            })
    }, [])
    const resetDetails = () => {
        setEmail('')
        setFirstName('')
        setLastName('')
        setRole('')
        setIsActive('true')
        setPassword('')
        setEditUserIndex(-1)
        setEditUser(null)
    }
    const checkDisable = () => {
        if (editUser) {
            if(email == '' || firstName == '' || lastName == '' || client == null || client == '') {
                return true
            }
        } else if(email == '' || firstName == '' || lastName == '' || password == '' || client == null || client == '') {
            return true
        }
        return false
    }

    const getUserName = (fname: string, lname: string) => {
        if(fname && lname) {
            return  `${fname} ${lname}`
        } else if(fname || lname) {
            if(fname) {
                return fname
            } else {
                return lname
            }
        } else {
            return ''
        }
    }
    if ('rahul.khanna@edfora.com' === props.userData.authenticatedUser.email) {

        return (
            <div>
                <div>
                    <div style={{ float: 'right' }}>
                        <Link style={styles.padding} to="/client" >Client</Link>
                        <Link style={styles.padding} to="/user" >User</Link>
                        <Link style={styles.padding} to="/role" >Role</Link>
                        <Link style={styles.padding} to="/user-list" >User List</Link>
                    </div>

                    <div><p style={{ color: "red" }}>{resMsg}</p></div>
                    <select name="client" onChange={(e) => {
                        resetDetails()
                        setClient(e.target.value)
                        getClientRole(e.target.value)
                            .then((res: any) => {
                                const roles = res.responseObject
                                // roles.pop()
                                setClientRoles(roles)
                            })
                            .catch()
                        getUsers(e.target.value)
                            .then((res: any) => {
                                const users = res.responseObject
                                // users.pop()
                                setUsers(users)
                            })
                            .catch()

                    }}>
                        <option value=""> Select Client</option>
                        {
                            clients.map((client: any) => {
                                return <option value={client._id}> {client.name} </option>
                            })
                        }
                    </select>

                    <h2>{editUser ? 'Edit' : 'Create'} User </h2>
                    <div style={styles.padding}>
                        <input type="email" onChange={(e) => { setEmail(e.target.value) }} value={email} placeholder="Enter Email" />
                    </div>
                    <div style={styles.padding}>
                        <input type="text" onChange={(e) => { setFirstName(e.target.value) }} value={firstName} placeholder="Enter Firstname" />
                    </div>
                    <div style={styles.padding}>
                        <input type="text" onChange={(e) => { setLastName(e.target.value) }} value={lastName} placeholder="Enter Lastname" />
                    </div>
                    <div style={styles.padding}>
                        <select name="role" value={role} onChange={(e) => {
                            setRole(e.target.value)
                        }}>
                            <option value=''> Select Role</option>
                            {clientRoles.map((role: any) => {
                                return <option value={role._id}> {role.role}</option>
                            })}
                        </select>
                    </div>
                    <div style={styles.padding}>
                        <select name="isActive" value={isActive} onChange={(e) => {
                            setIsActive(e.target.value)
                        }}>
                            <option value={'true'}> Active</option>
                            <option value={'false'}> InActive</option>
                        </select>
                    </div>
                    <div style={styles.padding}>
                        {!editUser &&
                            <input type="password" onChange={(e) => { setPassword(e.target.value) }} value={password} placeholder="Enter password" />
                        }
                    </div>
                    <button
                        style={{ marginLeft: '10px' }}
                        onClick={(e) => {
                            e.preventDefault();
                            let body = {
                                "clientId": client,
                                "emailId": email,
                                "firstName": firstName,
                                "lastName": lastName,
                                "role": role,
                                "isActive": isActive,
                                "password": password
                            }
                            saveAndEditUser(body, editUser ? editUser._id : null)
                                .then((res: any) => {
                                    if (res.statusCode === 200) {
                                        if (editUser) {
                                            users[editUserIndex] = res.responseObject
                                            users[editUserIndex].role = clientRoles.find((role: any) => role._id === res.responseObject.role)
                                            setUsers([...users])
                                        } else {
                                            const newUser = { ...res.responseObject.responseObject }
                                            newUser.role = clientRoles.find((role: any) => role._id === res.responseObject.responseObject.role)
                                            setUsers([...users, newUser])
                                        }
                                    } else {
                                        setResMsg(res.responseMessage)
                                        setTimeout(() => {
                                            setResMsg('')
                                        }, 5000)
                                    }
                                })
                                .catch(() => {

                                })

                        }}
                        disabled={checkDisable()}
                    >
                        {editUser ? 'Edit' : 'Create'}
                    </button>
                    <button
                        onClick={(e) => {
                            e.preventDefault();
                            resetDetails()
                        }}
                    >
                        Clear
                </button>
                </div>
                <div>
                    <h2>User List </h2>
                    <table>
                        <tr>
                            <td>S.no</td>
                            <td>Email</td>
                            <td>Name</td>
                            <td>Role</td>
                        </tr>
                        {users.map((user: any, index: number) => {
                            return <tr>
                                <td>{index + 1}</td>
                                <td>{user.email && user.email}</td>
                                <td>{getUserName(user.firstName, user.lastName)}</td>
                                <td>{user.role && user.role.role && user.role.role}</td>
                                <td><button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setEditUser(user)
                                        setEmail(user.email)
                                        setFirstName(user.firstName)
                                        setLastName(user.lastName)
                                        setRole(user.role ? user.role._id.toString(): '')
                                        setIsActive(user.isActive.toString())
                                        setPassword(user.password)
                                        setEditUserIndex(index)
                                    }}
                                >
                                    Edit
                            </button></td>
                            </tr>
                        })}
                    </table>
                </div>
            </div>
        )
    } else {
        return <h1> Not permitted </h1>
    }
}


const mapStateToProps = (state: any) => ({
    userData: state.loginData.userData
})


export default connect(mapStateToProps)(UserComponent);
